if (!customElements.get('makeup-feature-product-card')) {
  class MakeupFeatureProductCard extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.select = this.querySelector('[data-mfs-variant-select]');
      this.variantData = this.querySelector('[data-mfs-variant-data]');

      if (!this.select || !this.variantData) return;

      try {
        this.variants = JSON.parse(this.variantData.textContent);
      } catch (error) {
        console.warn('Unable to read Makeup Feature Story variants.', error);
        return;
      }

      this.image = this.querySelector('[data-mfs-product-image]');
      this.price = this.querySelector('[data-mfs-product-price]');
      this.selectedValue = this.querySelector('[data-mfs-selected-variant]');
      this.addButton = this.querySelector('[data-mfs-add-to-cart]');
      this.swatches = Array.from(this.querySelectorAll('[data-mfs-variant-swatch]'));
      this.productLinks = Array.from(this.querySelectorAll('[data-mfs-product-link]'));
      this.productUrl = this.querySelector('[data-mfs-product-url]')?.dataset.mfsProductUrl;

      this.select.addEventListener('change', () => this.updateVariant(this.select.value));
      this.swatches.forEach((swatch) => {
        swatch.addEventListener('click', () => {
          const variant = this.findVariantForOption(swatch);
          if (!variant) return;

          this.select.value = String(variant.id);
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      this.updateVariant(this.select.value);
    }

    findVariantForOption(swatch) {
      const optionIndex = Number(swatch.dataset.optionPosition) - 1;
      const optionValue = swatch.dataset.optionValue;
      const currentVariant = this.variants.find((item) => String(item.id) === String(this.select.value));
      const desiredOptions = currentVariant ? [...currentVariant.options] : [];

      desiredOptions[optionIndex] = optionValue;

      return this.variants.find((variant) => (
        variant.available &&
        variant.options.every((value, index) => value === desiredOptions[index])
      )) || this.variants.find((variant) => (
        variant.available && variant.options[optionIndex] === optionValue
      )) || this.variants.find((variant) => variant.options[optionIndex] === optionValue);
    }

    updateVariant(variantId) {
      const variant = this.variants.find((item) => String(item.id) === String(variantId));
      if (!variant) return;

      this.select.value = String(variant.id);

      if (this.price) this.price.textContent = variant.price;
      if (this.selectedValue) this.selectedValue.textContent = variant.title;

      let activeSwatch = null;
      this.swatches.forEach((swatch) => {
        const optionIndex = Number(swatch.dataset.optionPosition) - 1;
        const isActive = variant.options[optionIndex] === swatch.dataset.optionValue;
        swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        if (isActive) activeSwatch = swatch;
      });

      this.updateVisualImage(activeSwatch);

      if (this.addButton) {
        this.addButton.disabled = !variant.available;
        this.addButton.textContent = variant.available
          ? this.addButton.dataset.addLabel
          : this.addButton.dataset.soldOutLabel;
      }

      if (this.productUrl) {
        const variantUrl = `${this.productUrl}?variant=${variant.id}`;
        this.productLinks.forEach((link) => {
          link.href = variantUrl;
        });
      }
    }

    updateVisualImage(activeSwatch) {
      if (!this.image) return;

      if (activeSwatch?.dataset.imageSrc) {
        this.image.src = activeSwatch.dataset.imageSrc;
        this.image.srcset = activeSwatch.dataset.imageSrcset || '';
        this.image.alt = activeSwatch.dataset.imageAlt || '';
        return;
      }

      if (this.image.dataset.mfsBaseSrc) {
        this.image.src = this.image.dataset.mfsBaseSrc;
        this.image.srcset = this.image.dataset.mfsBaseSrcset || '';
        this.image.alt = this.image.dataset.mfsBaseAlt || '';
      }
    }
  }

  customElements.define('makeup-feature-product-card', MakeupFeatureProductCard);
}
